export const Common = {
  pls_wait_icon: "loading",
};

export default Common;
